<template>
  <div class="WorkDetails">
    <home-header :isShow="true"></home-header>
    <!-- // 1;//音频类 2;//视频类3;//文本类 4;//图片类 5;//打卡类 -->
    <!-- 音频 -->
    <audio-details
      :activityId="activityId"
      :audioDetails="audioData"
      :commentNum="commentNum"
      v-if="type === '1'"
      :ShowComment="isShowComment"
    ></audio-details>
    <!-- 视频 -->
    <video-details
      :activityId="activityId"
      :videoDetails="videoData"
      v-if="type === '2'"
      :ShowComment="isShowComment"
    ></video-details>
    <!-- 摄影 -->
    <img-details
      :activityId="activityId"
      :imgDetails="imgData"
      v-if="type === '4'"
      :ShowComment="isShowComment"
    ></img-details>
    <!-- 征文 -->
    <text-details
      :activityId="activityId"
      :textDetails="textData"
      v-if="type === '3'"
      :ShowComment="isShowComment"
    ></text-details>
    <text-details
      :activityId="activityId"
      :textDetails="textData"
      v-if="type === '13'"
      :ShowComment="isShowComment"
    ></text-details>
    <comment-details
      v-if="isShowComment"
      @commentNum="getCommentNum"
      :activityId="activityId"
      :workId="id"
    ></comment-details>
    <login-footer></login-footer>
  </div>
</template>
<script>
// import HomeHeader from '@/components/Header'
import HomeHeader from "@/components/homeHeader";

import LoginFooter from "@/components/LoginFooter";
import VideoDetails from "./components/video";
import AudioDetails from "./components/audio";
import ImgDetails from "./components/img";
import TextDetails from "./components/text";
import CommentDetails from "./components/comment";
export default {
  name: "WorkDetails",
  components: {
    HomeHeader,
    LoginFooter,
    VideoDetails,
    CommentDetails,
    AudioDetails,
    ImgDetails,
    TextDetails
  },
  data() {
    return {
      id: "",
      activityId: "",
      type: "",
      audioData: "",
      commentNum: "",
      videoData: "",
      imgData: "",
      textData: "",
      activityData: ""
    };
  },
  computed: {
    isShowComment() {
      // return this.activityId == 426 ? false : true;
      if (this.activityData) {
        return this.activityData.activity_is_mark == 2 ? false : true;
      } else {
        return false;
      }
    }
  },

  mounted() {
    this.getDetails();
  },
  methods: {
    getCommentNum(data) {
      this.commentNum = data;
    },
    getDetails() {
      this.id = this.$route.params.id;
      this.type = this.$route.params.type;
      console.log(this.id, this.type);
      let id = this.$route.params.id;
      let type = this.$route.params.type;
      this.$api
        .worksDetails({ id: id })
        .then(res => {
          if (res.code == 200) {
            console.log("活动详情===", res.data);
            this.activityData = res.data;
            console.log(111, res.data.activity_id);
            this.activityId = res.data.activity_id;
            // 1;//音频类 2;//视频类3;//文本类 4;//图片类 5;//打卡类
            if (type == 1) {
              this.audioData = res.data;
              console.log(this.audioData);
            } else if (type == 2) {
              this.videoData = res.data;
            } else if (type == 3 || type == 13) {
              this.textData = res.data;
            } else if (type == 4) {
              this.imgData = res.data;
            }
            sessionStorage.setItem("activity_id", res.data.activity_id);
          }
        })
        .catch(err => console.log(err));
    }
  }
};
</script>
<style scoped>
.WorkDetails {
  background: #f3f3f3;
}

.grid-content >>> .comment_icons {
  margin: 0px;
  width: 100%;
  text-align: right !important;
}

.grid-content {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/workdetails/WorkDetails.vue